// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRecordDetailsSummaryDto
 */
export interface IRecordDetailsSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof IRecordDetailsSummaryDto
     */
    record_id: number;
    /**
     * 
     * @type {number}
     * @memberof IRecordDetailsSummaryDto
     */
    ee_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecordDetailsSummaryDto
     */
    er_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecordDetailsSummaryDto
     */
    tax_year: number;
    /**
     * 
     * @type {Date}
     * @memberof IRecordDetailsSummaryDto
     */
    contribution_date: Date;
}

/**
 * Check if a given object implements the IRecordDetailsSummaryDto interface.
 */
export function instanceOfIRecordDetailsSummaryDto(value: object): value is IRecordDetailsSummaryDto {
    if (!('record_id' in value) || value['record_id'] === undefined) return false;
    if (!('tax_year' in value) || value['tax_year'] === undefined) return false;
    if (!('contribution_date' in value) || value['contribution_date'] === undefined) return false;
    return true;
}

export function IRecordDetailsSummaryDtoFromJSON(json: any): IRecordDetailsSummaryDto {
    return IRecordDetailsSummaryDtoFromJSONTyped(json, false);
}

export function IRecordDetailsSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRecordDetailsSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'record_id': json['record_id'],
        'ee_amount': json['ee_amount'] == null ? undefined : json['ee_amount'],
        'er_amount': json['er_amount'] == null ? undefined : json['er_amount'],
        'tax_year': json['tax_year'],
        'contribution_date': (new Date(json['contribution_date'])),
    };
}

export function IRecordDetailsSummaryDtoToJSON(json: any): IRecordDetailsSummaryDto {
    return IRecordDetailsSummaryDtoToJSONTyped(json, false);
}

export function IRecordDetailsSummaryDtoToJSONTyped(value?: IRecordDetailsSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'record_id': value['record_id'],
        'ee_amount': value['ee_amount'],
        'er_amount': value['er_amount'],
        'tax_year': value['tax_year'],
        'contribution_date': ((value['contribution_date']).toISOString().substring(0,10)),
    };
}

